
import 'mousetrap';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { TranslateModule } from '@ngx-translate/core';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FileUploadService } from 'app/core/files/file-upload.service';
import { NotificationsModule } from 'app/notifications/notifications.module';
import { DataGridModule } from 'app/shared/components/data-grid/data-grid.module';
import { CURRENCY_MASK_CONFIG, CurrencyInputDirection, CurrencyMaskConfig } from 'app/shared/currency/currency-mask.config';
import { CurrencyMaskModule } from 'app/shared/currency/currency-mask.module';
import { UtcDatePipe } from 'app/shared/pipes/UtcDatePipe';
import { GridService } from 'app/shared/services/xrm/grid.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { XRMConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { StopEnterDirective } from './directives/stop-enter.directive';
import { TitleResolver } from './resolvers/title.resolver';
import { UtilsService } from './services/utils.service';
import { VehicleImagesModule } from './vehicleimages.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { PaginatorComponent } from './components/paginator/paginator.component';


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  direction: CurrencyInputDirection.LeftToRight,
  allowNegative: false,
  decimal: '.',
  precision: 2,
  prefix: '$ ',
  suffix: '',
  thousands: ',',
  selectOnFocus: true,
  removeMaskDuringEntry: true
};

@NgModule({
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule,
    CurrencyMaskModule,
    FlexLayoutModule,
    FormsModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    NotificationsModule,
    TranslateModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTabsModule,
    DataGridModule,
    DragDropModule,
    GalleryModule.forRoot(),
    VehicleImagesModule,
    MatDividerModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTableModule
  ],
  declarations: [
    StopEnterDirective,
    StepperComponent,
    XRMConfirmDialogComponent,
    FileUploaderComponent,
    PaginatorComponent,
    UtcDatePipe
  ],
  providers: [
    UtilsService,
    TitleResolver,
    GridService,
    MatDatepickerModule,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  exports: [
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatRippleModule,
    MatTabsModule,
    CurrencyMaskModule,
    NgxDatatableModule,
    TranslateModule,
    RouterModule,
    BsDropdownModule,
    MatSnackBarModule,
    DataGridModule,
    StopEnterDirective,
    StepperComponent,
    DatatableComponent,
    XRMConfirmDialogComponent,
    FileUploaderComponent,
    PaginatorComponent,
    UtcDatePipe,
    VehicleImagesModule
  ],
  entryComponents: [XRMConfirmDialogComponent, DatatableComponent, StepperComponent, FileUploaderComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}
